import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

class FetchLiveRoomListByProductIdApi extends Service {
  constructor(params: any) {
    super()
    this.name = 'FETCH_LIVE_ROOM_LIST_BY_PRODUCT_ID'

    this.config = {
      url: `/v1/product/live-room`,
      method: 'GET',
      params: { ...params },
    }
  }
}

export const fetchLiveRoomListByProductId = (params: any) => getCallApiFunction(new FetchLiveRoomListByProductIdApi(params))
